module.exports = __webpack_public_path__ + "img/popAr.f1b50047.png";